import * as Yup from 'yup';

export const formIOSettingsSchema = Yup.object().shape({
    liveEndpoint: Yup.string().required("Please enter live endpoint"),
    username: Yup.string().required("Please enter username"),
    // Blank = keep the existing stored password (secrets are no longer returned by the API).
    password: Yup.string()
})


